import React from 'react';
import { useTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Text from 'components/Text';
import CenterContent from 'components/CenterContent';
import Stack from 'components/Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorContent(_ref) {
  var errorMessage = _ref.errorMessage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(CenterContent, {
    height: "90vh",
    contentWidth: 440,
    children: /*#__PURE__*/_jsx(Landmark, {
      icon: "logout",
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "m",
        children: [/*#__PURE__*/_jsx(Text, {
          bold: true,
          as: "p",
          children: t('error_whoops_there_has_been_an_error')
        }), errorMessage && /*#__PURE__*/_jsx(Text, {
          children: t(errorMessage)
        })]
      })
    })
  });
}
export default ErrorContent;